import React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

const TAB_TO_PATH = {
  overview: '/admin/mcp/overview',
  keys: '/admin/mcp/keys',
  tools: '/admin/mcp/tools',
  logs: '/admin/mcp/logs',
}

export default function McpLegacyRedirect() {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const target = TAB_TO_PATH[tab] ?? '/admin/mcp/overview'
  return <Navigate to={target} replace />
}
